import { useEffect, useRef, useState } from 'react';

import { safeCalculateMindedResources } from '@/common/lib/safeCalculateMindedResources';
import { selectBoostForFactory } from '@/redux/selectors/factoryReducer';
import { useAppSelector } from '@/redux/store';

import { type UserFactory } from '../types/factoryType';
const useMaterialProduction = (factory?: UserFactory): number => {
  const boosts = useAppSelector((state) =>
    selectBoostForFactory(state, factory?.id),
  );
  const timerId = useRef<NodeJS.Timeout | undefined>();
  const [productedBy, setProductedBy] = useState<number>(0);

  useEffect(() => {
    if (factory) {
      clearInterval(timerId.current);
      setProductedBy(0);

      const changeProductedMaterials = () => {
        const updatedAt = new Date();

        return (): void => {
          const plant = {
            updatedAt,
            productionRate: factory.productionRateOriginal,
            boosts: boosts || [],
          };

          const producted = safeCalculateMindedResources(plant);
          setProductedBy(producted);
        };
      };

      if (factory.incommingStorage) {
        changeProductedMaterials()();

        timerId.current = setInterval(changeProductedMaterials(), 1000);
      }
    }

    return (): void => {
      clearInterval(timerId.current);
    };
  }, [factory]);

  useEffect(() => {
    return (): void => clearInterval(timerId.current);
  }, []);

  useEffect(() => {
    if (factory) {
      if (productedBy >= factory.incommingStorage) {
        clearInterval(timerId.current);
      }
    }
  }, [productedBy, factory?.incommingStorage]);

  return productedBy;
};

export { useMaterialProduction };
